var _excluded = ["activecolor", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { StyledTabs } from './StyledTabs';
function Tabs(_ref) {
  var activecolor = _ref.activecolor,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledTabs, _extends({}, rest, {
    activecolor: activecolor,
    textColor: "inherit"
  }), children);
}
Tabs.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Color to highlight selected tab
   */
  activecolor: PropTypes.oneOf(['default', 'primary', 'primaryAlt', 'secondary', 'secondaryAlt', 'tertiary', 'info', 'inherit', 'light']).isRequired,
  /**
   * Callback fired when the component mounts. This is useful when you want to
   * trigger an action programmatically. It supports two actions: `updateIndicator()`
   * and `updateScrollButtons()`
   */
  action: PropTypes.func,
  /**
   * The content of the component.
   */
  children: PropTypes.node.isRequired,
  /**
   *
   */
  indicatorEdges: PropTypes.oneOf(['default', 'rounded']),
  /**
   *
   */
  indicatorElevation: PropTypes.bool,
  /**
   * Callback fired when the value changes.
   */
  onChange: PropTypes.func.isRequired,
  /**
   * The value of the currently selected Tab. If `false` no tab will be selected
   */
  value: PropTypes.any
} : {};
Tabs.defaultProps = {
  action: function action() {},
  indicatorEdges: 'default',
  indicatorElevation: false,
  value: false
};
export default Tabs;